import axios from 'axios'
import { withHeadersInstance } from './api-instance'
import qs from 'qs'

const baseUrl = process.env.VUE_APP_URL_API

axios.defaults.headers.common = {
    'Content-Type': 'application/json',
}

export const GetLocation = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined)
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )

        return await withHeadersInstance({
            method: 'get',
            url: `${baseUrl}/location/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PutLocation = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined) {
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        }

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/location/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const DeleteLocation = async function(parameters) {
    try {
        const { publicId } = parameters

        return await withHeadersInstance({
            method: 'delete',
            url: `${baseUrl}/location/${publicId}`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetList = async function(parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/locations${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
        })
    } catch (e) {
        console.error(e)
    }
}

export const GetListByClient = async function(locationId, parameters) {
    try {
        const queryUrl = '?' + qs.stringify(parameters)

        const url = `${baseUrl}/locations/client/${locationId}${queryUrl}`

        return await withHeadersInstance({
            method: 'get',
            url: url,
        })
    } catch (e) {
        console.error(e)
    }
}

export const PostLocation = async function(parameters) {
    try {
        return await withHeadersInstance({
            method: 'post',
            url: `${baseUrl}/location`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}

export const ChangeLocationStatus = async function(parameters) {
    try {
        const { publicId } = parameters

        if (publicId === undefined) {
            return Promise.reject(
                new Error('Missing required  parameter: publicId')
            )
        }

        return await withHeadersInstance({
            method: 'put',
            url: `${baseUrl}/location/${publicId}/change-status`,
            data: parameters,
        })
    } catch (e) {
        console.error(e)
    }
}